import { render, staticRenderFns } from "./OrderDetailsHero.vue?vue&type=template&id=03bcb225&scoped=true"
import script from "./OrderDetailsHero.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderDetailsHero.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./OrderDetailsHero.vue?vue&type=style&index=0&id=03bcb225&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bcb225",
  null
  
)

export default component.exports